import { render } from "./live-input-action.vue?vue&type=template&id=5d044c9f&scoped=true"
import script from "./live-input-action.vue?vue&type=script&lang=js"
export * from "./live-input-action.vue?vue&type=script&lang=js"

import "./live-input-action.vue?vue&type=style&index=0&id=5d044c9f&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d044c9f"]])

export default __exports__